import { ExternalLink, ImagePlus, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const imageUrl = (path) => (path ? `${BACKEND_URL}/api/files/${path}` : "");

export const PublicMenuSettings = ({ settings, uploading, saving, onChange, onUpload, onSave }) => {
  const publicIndexUrl = `${window.location.origin}/menu`;
  return (
    <section className="mb-7 border-b pb-7" style={{ borderColor: "#E6E4DD" }} data-testid="public-menu-settings">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: "#A89F9A" }} data-testid="public-menu-settings-eyebrow">Portada pública</p>
          <h2 className="mt-1 text-2xl font-heading font-bold" style={{ color: "#2A2A2A" }} data-testid="public-menu-settings-title">Índice de menús</h2>
        </div>
        <Button variant="outline" className="border-[#E6E4DD] bg-white" onClick={() => window.open(publicIndexUrl, "_blank")} data-testid="open-public-menu-index-button">
          <ExternalLink className="mr-2 h-4 w-4" /> Ver portada
        </Button>
      </div>
      <div className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] lg:items-end">
        <div className="space-y-2">
          <Label htmlFor="public-menu-logo-input">Logo de la empresa</Label>
          <div className="flex flex-wrap items-center gap-3">
            <label className="inline-flex cursor-pointer items-center gap-2 rounded-md border bg-white px-3 py-2 text-sm font-medium" style={{ borderColor: "#E6E4DD" }} data-testid="public-menu-logo-upload-label">
              <ImagePlus className="h-4 w-4" style={{ color: "#C05C46" }} /> {uploading ? "Subiendo..." : "Subir logo"}
              <input id="public-menu-logo-input" type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={onUpload} data-testid="public-menu-logo-upload-input" />
            </label>
            {settings.logo_path ? <img src={imageUrl(settings.logo_path)} alt="Logo de la empresa" className="h-11 max-w-40 object-contain object-left" data-testid="public-menu-logo-preview" /> : <span className="text-sm" style={{ color: "#A89F9A" }} data-testid="public-menu-logo-empty">Sin logo</span>}
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="public-menu-background-color">Color de fondo</Label>
          <div className="flex items-center gap-3">
            <input id="public-menu-background-color" type="color" value={settings.background_color} onChange={(event) => onChange((previous) => ({ ...previous, background_color: event.target.value.toUpperCase() }))} className="h-11 w-14 cursor-pointer rounded-md border bg-white p-1" style={{ borderColor: "#E6E4DD" }} data-testid="public-menu-background-color-picker" />
            <Input value={settings.background_color} onChange={(event) => onChange((previous) => ({ ...previous, background_color: event.target.value.toUpperCase() }))} maxLength={7} className="max-w-32 border-[#E6E4DD] bg-white font-mono uppercase" data-testid="public-menu-background-color-input" />
          </div>
        </div>
        <Button className="bg-[#C05C46] text-white hover:bg-[#A94F3C]" disabled={saving} onClick={onSave} data-testid="save-public-menu-settings-button">
          <Save className="mr-2 h-4 w-4" /> {saving ? "Guardando..." : "Guardar portada"}
        </Button>
      </div>
    </section>
  );
};